<template>
    <div>
        <div>
            <div v-for="(id, index) in selectedResourceIds" :key="id" class="reallocation-container">
                <div class="reallocation-item">
                    <div class="reallocation-select">
                        <select required :value="id" @change="ev => handleReallocationChange(ev, index)">
                            <option v-for="res in getResourceOptions(id)" :key="res.id" :value="res.id">{{ formatOptionsLabel(res) }}</option>
                        </select>
                    </div>
                    <div class="reallocation-icon">
                        <i class="material-icons" @click="removeSelect(id)">delete</i>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="reallocation-add" v-on:click="addSelect">
                <i class="material-icons">add</i>
                <span>Adicionar lugar</span>
            </div>
        </div>
    </div>
</template>

<script>
import { validation } from '../helpers';

export default {
    props: {
        seatMap: Object,
        currentResourceIds: Array,
        allowUnavailable: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    data(){
        const resourceOptions = this.seatMap.areas.reduce((arr, area) => {
            for (let slot of area.slots) {
                if (slot.type !== 'resource') {
                    continue;
                }

                const { ok: isAvailable } = validation.resourceIsAvailable(this.seatMap, slot.resource, this.currentResourceIds);
                arr = [...arr, { ...slot.resource, isAvailable }];
            }

            return arr;
        }, []);

        resourceOptions.sort((a, b) => b.isAvailable && !a.isAvailable ? 1 : -1);

        const selectedResourceIds = resourceOptions.filter(res => this.currentResourceIds.includes(res.id)).map(res => res.id);

        return { resourceOptions, selectedResourceIds };
    },
    computed: {
        availableReallocationResources(){
            return this.resourceOptions.filter(res => !this.selectedResourceIds.includes(res.id));
        }
    },
    methods: {
        addSelect(){
            this.selectedResourceIds = [...this.selectedResourceIds, this.availableReallocationResources[0]?.id ?? null];

            this.emitSelectedResources();
        },
        removeSelect(id){
            this.selectedResourceIds = this.selectedResourceIds.filter(i => i !== id);

            this.emitSelectedResources();
        },
        handleReallocationChange(ev, index){
            this.selectedResourceIds = this.selectedResourceIds.map((i, idx) => idx === index ? ev.target.value ?? null : i);

            this.emitSelectedResources();
        },
        getResourceOptions(id){
            const resources = this.resourceOptions.filter(res => !this.selectedResourceIds.includes(res.id) || res.id === id);

            if (this.allowUnavailable) {
                return resources;
            }

            return resources.filter(resource => !resource.taken);
        },
        formatOptionsLabel(res){
            return `${(res.isAvailable ? '' : '(Indisponível) ')}${res.name} (${res.capacity} lugar${res.capacity === 1 ? '' : 'es'})`;
        },
        emitSelectedResources(){
            const optionsIndex = this.resourceOptions.reduce((idx, res) => ({ ...idx, [res.id]: res }), {});
            const resources = this.selectedResourceIds.filter(id => id !== null).map(id => optionsIndex[id]);

            this.$emit('onSelectedResources', resources);
        }
    },
    mounted(){
        this.emitSelectedResources();
    }
}
</script>

<style lang="scss" scoped>
.reallocation-container {
    .reallocation-select {
        margin: 5px 0px;

        select {
            max-width: 225px;
        }
    }
    .reallocation-icon {
        cursor: pointer;
        margin: 2px 4px;
    }
}

.reallocation-item {
    display: flex;
}

.reallocation-add {
    cursor: pointer;
    display: flex;
    margin-bottom: 10px;

    span {
        font-size: 15px;
        margin-left: 5px;
        margin-top: 2px;
    }
}
</style>
